import React from "react";
import FormPrintDan from "./FormPrintDan";
import rahel from "./../../../img/rahel1.jpg";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const InputPrintDan = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { RPD_from, RPD_to, RPD_para$, RPD_paraID, RPD_paraRRR } =
            value;
          return (
            <>
              <img src={rahel} alt="rahel" />
              <div className="row mb2">
                <div className="col-md-4 text-right form-inline "></div>
                <div className="col-md-4 text-right form-inline ">
                  <div className="form-group ">
                    <label className="font-weight-bold f3 ml5">
                      ڕاپۆرتی پارەدان
                    </label>
                  </div>
                </div>
                <div className="col-md-4 text-right form-inline"></div>
              </div>

              <div
                className="row text-dark font-weight-bold f3 mx-4"
                style={{ border: "2px solid black" }}
              >
                <div className="col-md-5 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5 ">{RPD_to}</h5>
                    <label className="font-weight-bold mb-2 ml1">
                      : بۆ بەرواری
                    </label>
                  </div>
                </div>

                <div className="col-md-5 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5  ">{RPD_from}</h5>
                    <label className="font-weight-bold mb-2  ml1">
                      : لە بەرواری{" "}
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt4"></div>
              <FormPrintDan />
              {/* first row */}
              <div className="row">
                <div className="col-12">
                  <div className="row ">
                    <div className="col-3">
                      <h2 className="bg-white tc mt-mt-2">
                        <NumberFormat
                          value={RPD_paraID}
                          className=" font-weight-bold  tc "
                          displayType={"text"}
                          prefix={"ID"}
                          thousandSeparator={true}
                        />
                      </h2>
                    </div>
                    <div className="col-3">
                      <h2 className=" tc  mt-2 ">پارە بە دینار</h2>
                    </div>

                    <div className="col-3 ">
                      <h2 className="bg-white tc mt-2">
                        <NumberFormat
                          value={RPD_para$}
                          className=" font-weight-bold  tc "
                          displayType={"text"}
                          prefix={"$"}
                          thousandSeparator={true}
                        />
                      </h2>
                    </div>
                    <div className="col-3">
                      <h2 className=" tc  mt-2">پارە بە دۆلار</h2>
                    </div>
                  </div>
                </div>
              </div>
              {/* footer rased Remembe */}
              <div className="row pt2">
                <div className="col-lg-10 col-md-12">
                  <div className="row ">
                    <div className="col-lg-3 col-md-4">
                      <h3 className="bg-white tc mt2">
                        <NumberFormat
                          displayType="text"
                          thousandSeparator={true}
                          value={Number(RPD_paraRRR).toFixed(2)}
                          className="font-weight-bold"
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-md-4">
                      <h3 className=" tc  mt1">RRR پارە بە</h3>
                    </div>
                    <div className="col-lg-2 col-md-4"></div>
                    <div className="col-lg-3 col-md-4">
                      {/* <h3 className="bg-white tc mt2"><NumberFormat displayType='text' thousandSeparator={true} value={Number(RB_paraRRR).toFixed(2)} /></h3> */}
                    </div>
                    <div className="col-lg-2 col-md-4 mt1">
                      {/* <h3 className="text-warning tc ">RRR پارە بە </h3> */}
                    </div>
                  </div>
                </div>
              </div>
              <br />
              {/* second row */}
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default InputPrintDan;
